export default __webpack_public_path__ + "static/media/cheaper-than-agents.7e8b5f02.svg";